import { ObjectOrArray, system } from '@wrisk/styled-system'
import { Properties } from 'csstype'

export interface CollapseProps {
  collapseWhenEmpty?: boolean
}

export const collapse = system({
  collapseWhenEmpty: {
    property: '&:empty' as keyof Properties,
    transform: (value: boolean): ObjectOrArray<number> =>
      value
        ? {
            paddingTop: 0,
            paddingRight: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            padding: 0,
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: 0,
            margin: 0,
            borderTopWidth: 0,
            borderRightWidth: 0,
            borderBottomWidth: 0,
            borderLeftWidth: 0,
            border: 0,
          }
        : {},
  },
})
